module.exports = Betslip;